import {Controller} from "stimulus";
import $ from 'jquery'
// Connects to data-controller="icici-accounts"
export default class extends Controller {
  connect() {
    $('.select2').select2();
  }

  change_form() {

    let input_val = event.target.value;
    let nameContainer = document.getElementById('name-container');
    let input_fields = document.querySelectorAll('#name-container input')
    if (input_val == 'Individual' || input_val == 'Proprietorship') {
      nameContainer.classList.remove('is-hidden')
      input_fields.forEach(input_field => {
        input_field.required = true
        input_field.value = ''
      })
    } else {
      nameContainer.classList.add('is-hidden')
      input_fields.forEach(input_field => {
        input_field.required = false
        input_field.value = ''
      })
      document.querySelector('[name="icici_account_opening[salutation]"]').value = 'M/S'
    }
  }

  addPerson() {
    document.querySelectorAll('.remove-person').forEach((ele) => {
      ele.classList.add('is-hidden');
    })
  }

  removePerson() {
    Array.from(document.querySelectorAll('.person')).pop().remove();
    if (document.querySelectorAll('.person').length > 1) {
      Array.from(document.querySelectorAll('.remove-person')).pop().classList.remove('is-hidden')
    }
    let href = document.querySelector('#add-persons > a').attributes['href'].value
    let url = href.split('?')[0] + `?count=${(parseInt(href.charAt(href.length - 1)) - 1)}`
    document.querySelector('#add-persons > a').attributes['href'].value = url
  }
}
